<template>
    <div class="slider-box">
        <h5>How much pH Balancer did you add?</h5>
        <w-button class="px-3 d-block mx-auto" @click="update()">Update</w-button>
        <small class="text-danger" v-if="error">{{error}}</small>
        <div class="line">
            <div></div>
        </div>
        <div class="row mt-3">
            <div class="col-5">
                <div class="line-label" :id="i" v-for="i in 10" :key="i">
                    <template v-if="~[0, 1, 1.75].indexOf(((10 - i) / 4)) || i === 1">
                        <span @click="value = (10 - i) / 4" v-if="i === 1" class="right cursor-pointer text-blue">Filled it up</span>
                        <span @click="value = (10 - i) / 4" v-else-if="i === 10" class="right cursor-pointer">0.0</span>
                        <span @click="value = (10 - i) / 4" v-else class="cursor-pointer right">{{(10 - i) / 4}} Bags</span>
                    </template>
                </div>
            </div>
            <div class="col-2">
                <span class="rounded-circle cursor-pointer" @click="value = 2.75"></span>
                <custom-range v-model="value" :min="0" :max="2.25" :step="0.25"></custom-range>
            </div>
            <div class="col-5">
                <div class="line-label" v-for="i in 10" :key="i">
                    <span @click="value = (10 - i) / 4" class="cursor-pointer left" v-if="(10 - i) / 4 <= 1.75">-</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomRange from './CustomRange'
import { mapGetters } from 'vuex'
import { lambda } from '@/amplify'

export default {
    name: 'Balancer',
    data () {
        return {
            value: 0,
            error: null
        }
    },
    methods: {
        update () {
            lambda('managePod', {
                podId: this.pool.pods[0].podId,
                refillableReq: {
                    acidBottlesAdded: this.value > 1.75 ? 1.75 : this.value,
                    ...(this.value > 1.75 && { phPctLeft: 100 })
                }
            }).then(data => {
                if (data.code === 'OK') this.$emit('update')
                else this.error = 'Something went wrong'
            }).catch(err => {
                this.error = err.message || 'Something went wrong'
            })
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool'
        })
    },
    components: { CustomRange },
    watch: {
        value (val, old) {
            if (val < 2.25 && val > 1.75) this.value = val < old ? 1.75 : 2.25
        }
    }
}
</script>

<style scoped>
    h5 {
        font-weight: 300;
    }

    @media (max-width: 576px) {
        h5 {
            margin-left: -15px;
            margin-right: -15px;
            font-size: 17px;
            margin-bottom: 15px;
        }
    }

    .slider-box {
        width: 250px;
    }

    .slider-box div.line {
        position: relative;
        top: 69px;
        margin: 0;
        z-index: 2;
        padding: 3px;
        background-color: #fff;
    }

    .slider-box div.line div {
        background-color: #d1d1d1;
        height: 2px;
        z-index: 3;
        width: 100%;
    }

    .text-blue {
        color: #47a4cb;
    }

    .line-label {
        height: 30px;
    }
    .line-label .text-blue {
        position: absolute;
        top: 0;
    }

    .rounded-circle {
        background-color: #fff;
        z-index: 1;
        width: 1.5em;
        height: 1.5em;
        position: absolute;
        border: 1px solid #ccc;
        left: 5px;
    }

    .cursor-pointer {
        cursor: pointer;
    }
</style>
